import { render, staticRenderFns } from "./Kline.vue?vue&type=template&id=252a4efe&scoped=true"
import script from "./Kline.vue?vue&type=script&lang=js"
export * from "./Kline.vue?vue&type=script&lang=js"
import style0 from "./Kline.vue?vue&type=style&index=0&id=252a4efe&prod&scoped=true&lang=less"
import style1 from "./Kline.vue?vue&type=style&index=1&id=252a4efe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252a4efe",
  null
  
)

export default component.exports